import ApiConfig from './api.config'
import ApiUtil from './api.util'
const ssoDomain = ApiConfig.ssoDomain
const platformDomain = ApiConfig.platformDomain
const singleDomain = ApiConfig.singleDomain


function fetchedLoginUserData(params) {

  return ApiUtil.post(`${ssoDomain}/v1/ebmp/login.json`, params);

}

function fetchedFindId(params) {

  return ApiUtil.post(`${ssoDomain}/v1/ebmp/findId.json`, params);

}

function fetchedConfirmId(params){
  return ApiUtil.post(`${ssoDomain}/v1/ebmp/confirmId.json` , params)
}

function fetchedConfirmAuthNumber(params){
  return ApiUtil.post(`${singleDomain}/v1/ebmp/main/user/confirmAuthNumber.json` , params)
}

function fetchedSendAuthNumber(params){
  return ApiUtil.post(`${singleDomain}/v1/ebmp/main/user/sendAuthNumber.json` , params)
}

function fetchedUpdatePassword(params){
  return ApiUtil.post(`${singleDomain}/v1/ebmp/main/user/updateUserPassword.json` , params)
}


export {
  fetchedLoginUserData,fetchedFindId,fetchedConfirmId,fetchedConfirmAuthNumber,fetchedSendAuthNumber,fetchedUpdatePassword
}
